
import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class AppHamburger extends Vue {
  @Prop({
    default: false,
  })
  public readonly toggled!: boolean;

  @Emit()
  public onToggle(): void {}
}
